<template>
  <v-flex xs12 row>

    <v-layout py-3>
   		<v-flex xs12>
   			<v-form v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              <v-flex xs12 sm4>
                <div class="subheading text-uppercase font-weight-light" v-if="purchaseReturn.code">
                  <span>ID: </span>
                  <span>{{purchaseReturn.code}}</span>
                </div>
                <div v-if="!purchaseReturn.purchase" class="py-2 px-3">
                  <v-autocomplete :loading="purchasesLoading" v-model="purchaseReturn.purchase_id" :search-input.sync="purchaseSearchText" :items="purchases" item-text="code" item-value="id" label="Search Purchase" hide-no-data>
                  </v-autocomplete>
                </div>
                <div v-else>
                  <div class="body-1">Bill No.: {{purchaseReturn.purchase.bill_number}}</div>
                </div>
              </v-flex>
              <v-flex xs6 sm4 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4">Purchase Return</span>
              </v-flex>
              <v-flex xs6 sm4 class="text-xs-right">
                <div class="body-2 font-weight-light py-2">
                  <v-icon class="mr-1">date_range</v-icon>
                  <span>{{purchaseReturn.date}}</span>
                </div>
              </v-flex>
            </v-card-title>

            <v-card-text>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left" v-if="isProductPurchase">
                                <span>Item Code</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <!-- <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right">
                                <span>Rate ({{currency}})</span>
                              </th> -->
                              <th role="columnheader" scope="col" class="column" :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>Purchase QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>Return QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right">
                                <span>Amount ({{currency}})</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode && !approveMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="purchaseReturn.purchase && purchaseReturn.items && purchaseReturn.items.length > 0">
                            <tr is="purchase-return-item" v-for="(item, index) in purchaseReturn.items" :item="item" :purchaseItems="purchaseReturn.purchase.items" :index="index" v-on:delete="deleteItem" :viewMode="viewMode" :approveMode="approveMode" :showCode="isProductPurchase"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-layout class="align-start justify-end column fill-height pr-3">
                      <div class="body-2" v-if="amountInWords">
                        <span class="grey--text text--darken-2">Total Return Amount (In Words): </span>
                        <span class="font-weight-light">{{amountInWords}}</span>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-right justify-end py-3 pl-3 pr-3">
                    <table class="total-table">
                      <tbody>
                        <tr class="body-2">
                          <td width="66%">Subtotal ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? purchaseReturn.subtotal : subtotal | roundValue }}</td>
                        </tr>
                        <tr class="body-1" v-if="!viewMode">
                          <td>
                            Discount (<span>{{ discount_percent }}</span>%): 
                          </td>
                          <td>
                            <span v-if="discount > 0">-</span>{{ discount | roundValue }}
                          </td>
                        </tr>
                        <tr class="body-1" v-else-if="purchaseReturn.purchase && purchaseReturn.purchase.discount_percent > 0">
                          <td>Discount (<span>{{ purchaseReturn.purchase.discount_percent }}</span>%):</td>
                          <td><span>-</span>{{ purchaseReturn.discount | roundValue }}</td>
                        </tr>
                        <tr class="body-1">
                          <td>Roundoff ({{currency}}): </td>
                          <td v-if="viewMode">{{ purchaseReturn.round_off | roundValue }}</td>
                          <td v-else>
                            <v-edit-dialog color="white" :return-value.sync="round_off" lazy @open="openRoundOff" @close="closeRoundOff" class="text-xs-right justify-end"> {{ purchaseReturn.round_off | roundValue }}
                              <v-text-field type="number" :rules="roundOffRules" slot="input" v-model="round_off" label="Enter Amount" single-line></v-text-field>
                            </v-edit-dialog>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <v-divider class="my-2"></v-divider>
                    <table class="total-table">
                      <tbody>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">Total Amount ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? purchaseReturn.total : total | roundValue }}</td>
                        </tr>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">GST ({{ purchaseReturn.purchase.tax_percent }}%): </td>
                          <td width="34%">{{ viewMode ? purchaseReturn.tax : tax | roundValue }}</td>
                        </tr>
                        <tr class="subheading font-weight-medium">
                          <td width="66%">Return Grand Total ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? purchaseReturn.grandtotal : grandtotal | roundValue }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!viewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" to="/purchase-return-list">Cancel</v-btn>
              <v-btn v-if="approveMode" color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="openConfirmDialog">Approve</v-btn>
              <v-btn v-else color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="upsertPurchaseReturn" v-text="purchaseReturn.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

		    <action-dialog action="approve" :status="confirmDialog" @close="closeConfirmDialog" @success="upsertPurchaseReturn" />

   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  import cloneDeep from 'lodash/cloneDeep'
  import get from 'lodash/get'
  import PurchaseReturnItem from './PurchaseReturnItem'

  export default {
    props: {
      viewMode: {
        type: Boolean,
        default: false
      },
      approveMode: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
      	title: "Purchase Return",
        validForm: false,
      	processing: false,
        purchasesLoading: false,
        purchaseSearchText: "",
        purchases: [],
        confirmDialog: false,
        round_off: 0,
        purchaseReturn: {},
        defaultReturn: {
          id: "",
          date: this.today('Do MMM, YYYY'),
          items: [],
          round_off: 0,
          tax: 0,
          purchase_id: null,
          purchase: null
        },
        requireRule: [
          v => !!v || 'Field is required'
        ],
        codeRules: [
            v => !!v || 'Item code is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        rateRules: [
            v => !!v || 'Rate is required',
            v => /^([0-9]{2,7})$/.test(v) || 'Rate must be valid'
        ],
        roundOffRules: [
          v => !!v || 'Amount is required',
          v => /^-?\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Amount must be valid'
        ]

      }
    },
    created () {

      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Purchase Return',
            disabled: false,
            href: '/purchase-return-list'
	        },
	        {
	          text: this.pageType,
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Purchase Return')
    },
    methods: {

      calculateItemTotal (item) {
        return item.quantity * ( item.rate + ( ( item.rate * item.tax_percent ) / 100) )
      },

      upsertPurchaseReturn () {

        if (this.purchaseReturn.items.length === 0) return this.notifyError('emptyPurchaseReturnItems')

        let zero_qty_items = this.purchaseReturn.items.filter(item => item.quantity === 0)

        if (zero_qty_items.length) {
          return this.notifyError('purchaseReturnItemsCountZero')
        }

        this.processing = true

        let data = this.extend(this.purchaseReturn, {
          discount: this.discount,
          total: this.total,
          subtotal: this.subtotal,
          tax: this.tax,
          grandtotal: this.grandtotal
        })

        let method = data.id ? 'put' : 'post'
        let api_path = data.id ? ( this.approveMode ? this.config.apis.approvePurchaseReturn.replace(":id", data.id) : this.config.apis.updatePurchaseReturn.replace(":id", data.id) ) : this.config.apis.savePurchaseReturn

        this.axios[method](api_path, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let successStatus = data.id ? 'updatePurchaseReturnSuccess' : 'insertPurchaseReturnSuccess'

              this.notifySuccess(successStatus)
              this.$router.push("/purchase-return-list")
            }
            else{

              let errorStatus = data.id ? 'updateError' : 'insertError'

              this.notifyError(errorStatus)
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.purchaseReturn.items.splice(index, 1)
      },

      initNewPurchaseReturn () {
        this.purchaseReturn = this.extend({}, this.defaultReturn)
      },

      loadPurchaseReturn (id) {
        this.processing = true
        
        let api_path = this.config.apis.getPurchaseReturn.replace(":id", id)

            api_path = this.approveMode ? `${api_path}?approveMode=true` : api_path

        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.purchaseReturn = response.data.data
            }
            else{
              this.purchaseReturn = this.initNewPurchaseReturn()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      openRoundOff () {
        this.round_off = parseFloat(this.purchaseReturn.round_off)
      },

      closeRoundOff () {
        this.purchaseReturn.round_off = parseFloat(this.round_off ? this.round_off : this.purchaseReturn.round_off)
      },

      openConfirmDialog () {
        this.confirmDialog = true
      },

      closeConfirmDialog () {
        this.confirmDialog = false
      },

      loadPurchase () {
        
        this.processing = true
        
        let api_path = this.config.apis.getPurchase.replace(":id", this.purchaseReturn.purchase_id)

        api_path = `${api_path}?status=${this.config.purchaseStatus.approved}`

        this.axios.get(api_path)
          .then((response) => {
            
            this.processing = false
            
            if (this.isSuccessResponse(response) && get(response, 'data.data.items')) {
              
              let purchase = response.data.data
              
              if (!this.purchaseReturn.id) {
                
                let return_items = purchase.items.map(item => {
                    item['damage_quantity'] = 0
                    item['non_damage_quantity'] = item['quantity']
                    return item
                  })
                this.purchaseReturn.items = cloneDeep(return_items)
              }
              this.purchaseReturn.purchase = purchase
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchPurchases () {

        let api_path = this.config.apis.getPurchases.replace(":page", 1).replace(":perPage", 5)

        api_path = `${api_path}?status=${this.config.purchaseStatus.approved}&code=${this.purchaseSearchText}&code_like=true`
        
        this.processing = true
        this.axios.get(api_path)
          .then(response => {
            this.processing = false
            this.purchases = this.isSuccessResponse(response) ? response.data.data.items : []
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },
    mounted () {
      if (this.$route.params.purchaseReturnId) {
        this.loadPurchaseReturn(this.$route.params.purchaseReturnId)
      }
      else{
        this.initNewPurchaseReturn()
      }
    },

    computed: {

      hasPurchase() {
        return !!this.purchaseReturn.purchase
      },

      subtotal () {
        
        let total = 0
        
        if (this.purchaseReturn.items) {
          this.purchaseReturn.items.forEach( item => {
            total += item.total
          })
        }
        
        return total
      },

      total () {
        return ( this.subtotal + this.purchaseReturn.round_off ) - this.discount
      },

      tax () {
        return this.total * this.purchaseTaxPercent / 100
      },

      purchaseTaxPercent () {
        return this.hasPurchase ? this.purchaseReturn.purchase.tax_percent : 0
      },

      grandtotal () {
        return this.tax + this.total
      },

      discount () {
        return ( this.subtotal * this.discount_percent ) / 100
      },

      pageType () {
        
        let title = "Add"
        
        if (this.viewMode) {
          title = "View"
        }
        else if(this.approveMode) {
          title = "Approve"
        }
        else if(this.$route.params.purchaseReturnId) {
          title = "Edit"
        }

        return title

      },

      amountInWords () {
        return this.amountToWords(this.grandtotal)
      },

      discount_percent () {
        return this.hasPurchase && this.purchaseReturn.purchase.discount_percent ? this.purchaseReturn.purchase.discount_percent : 0
      },

      tax_percent () {
        return this.hasPurchase ? this.purchaseReturn.purchase.tax_percent : 0
      },

      isProductPurchase () {
        return this.hasPurchase && this.purchaseReturn.purchase.purchase_type == this.config.purchaseTypes.product
      },

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.purchaseReturnId) {
          this.loadPurchaseReturn(to.params.purchaseReturnId)
        }
        else{
          this.purchaseReturn = this.initNewPurchaseReturn()
        }

      },

      purchaseSearchText (val) {
        if (val) {
          this.searchPurchases()
        }
      },

      'purchaseReturn.round_off' (val, oldVal) {
        if (!val) {
          this.purchaseReturn.round_off = 0
        }
      },

      'purchaseReturn.purchase_id' (val, oldVal) {
        if (val) {
          this.loadPurchase()
        }
      }

    },
    
    components: {
      'purchase-return-item': PurchaseReturnItem
    }

  }
</script>
